import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoBudgetClassification extends Component {

    render() {
        const { budgetClassification } = this.props;
        const summary = getTitleSummary(budgetClassification)
        return (
            <CodeInfoSection 
                title={{
                    headers: ['Соответствие наименований подакцизных товаров кодам ТНВЭД ЕАЭС и кодам бюджетной классификации РФ'],
                    rows: summary
                }}
                expanded={(budgetClassification.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Описание',
                        'Примечание',
                        'Код',
                        'Нормативный документ'
                    ],
                    rows: budgetClassification.map(({ to_date = null, description = '', notice = '', budget_code = '', begin_order, begin_order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        description,
                        notice,
                        budget_code,
                        formatOrder(begin_order, begin_order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoBudgetClassification.js